import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import index from '@/components/index/index'
import login from '@/components/login/login'
import ForgetPassword from '@/components/ForgetPassword/ForgetPassword'
import ResetPassword from '@/components/ResetPassword/ResetPassword'
import CourseDetails from '@/components/CourseDetails/CourseDetails'
import applay from '@/components/CourseDetails/applay'
import newsList from '@/components/news/list/list'
import newsDetails from '@/components/news/details/details'
import learning from '@/components/learning/learning'
import notice from '@/components/notice/notice'
import userInfo from '@/components/userInfo/userInfo'
import userInformation from '@/components/userInfo/Information/Information'
import userSetup from '@/components/userInfo/Setup/Setup'
import userTraining from '@/components/userInfo/training/training'
import userLive from '@/components/userInfo/live/live'
import userCourse from '@/components/userInfo/course/course'
import userIntegral from '@/components/userInfo/integral/integral'
import userFocus from '@/components/userInfo/focus/focus'
import teacherList from '@/components/teacher/teacher'
import teacherDetails from '@/components/teacher/details/details'
import live from '@/components/live/live'
import liveDetails from '@/components/live/details/details'
import videoLayer from '@/components/videoLayer/videoLayer'
import liveLayer from '@/components/liveLayer/liveLayer'
import searchVue from '@/components/search/search'
import CourseList from '@/components/CourseList/CourseList'
import AskForLeave from '@/components/userInfo/AskForLeave/AskForLeave'

Vue.use(Router)

const vueRouter = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        title: '首页'
      },
      component: index
    },
    {
      path: '/CourseList',
      name: 'CourseList',
      meta: {
        title: '公开课'
      },
      component: CourseList
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: login
    },
    {
      path: '/ForgetPassword',
      name: 'ForgetPassword',
      meta: {
        title: '忘记密码'
      },
      component: ForgetPassword
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      meta: {
        title: '重置密码'
      },
      component: ResetPassword
    },
    {
      path: '/CourseDetails',
      name: 'CourseDetails',
      meta: {
        title: '课程详情'
      },
      component: CourseDetails
    },
    {
      path: '/applay',
      name: 'applay',
      meta: {
        title: '课程详情'
      },
      component: applay
    },
    {
      path: '/newsList',
      name: 'newsList',
      meta: {
        title: '新闻资讯'
      },
      component: newsList
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      meta: {
        title: '新闻资讯-详情'
      },
      component: newsDetails
    },
    {
      path: '/learning',
      name: 'learning',
      meta: {
        title: '学习中心'
      },
      component: learning
    },
    {
      path: '/notice',
      name: 'notice',
      meta: {
        title: '通知'
      },
      component: notice
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      meta: {
        title: '个人中心'
      },
      component: userInfo,
      redirect: '/userInfo/userInformation',
      children: [
        {
          path: '/userInfo/userInformation',
          name: 'userInformation',
          meta: {
            title: '个人信息'
          },
          component: userInformation
        },
        {
          path: '/userInfo/userSetup',
          name: 'userSetup',
          meta: {
            title: '安全设置'
          },
          component: userSetup
        },
        {
          path: '/userInfo/AskForLeave',
          name: 'AskForLeave',
          meta: {
            title: '教师请假'
          },
          component: AskForLeave
        },
        {
          path: '/userInfo/userTraining',
          name: 'userTraining',
          meta: {
            title: '培训记录'
          },
          component: userTraining
        },
        {
          path: '/userInfo/userLive',
          name: 'userLive',
          meta: {
            title: '直播预约'
          },
          component: userLive
        },
        {
          path: '/userInfo/userCourse',
          name: 'userCourse',
          meta: {
            title: '线上课程'
          },
          component: userCourse
        },
        {
          path: '/userInfo/userIntegral',
          name: 'userIntegral',
          meta: {
            title: '我的积分'
          },
          component: userIntegral
        },
        {
          path: '/userInfo/userFocus',
          name: 'userFocus',
          meta: {
            title: '我的关注'
          },
          component: userFocus
        }
      ]
    },
    {
      path: '/teacherList',
      name: 'teacherList',
      meta: {
        title: '老师列表'
      },
      component: teacherList
    },
    {
      path: '/teacherDetails',
      name: 'teacherDetails',
      meta: {
        title: '老师详情'
      },
      component: teacherDetails
    },
    {
      path: '/liveDetails',
      name: 'liveDetails',
      meta: {
        title: '直播'
      },
      component: liveDetails
    },
    {
      path: '/live',
      name: 'live',
      meta: {
        title: '直播详情'
      },
      component: live
    },
    {
      path: '/videoLayer',
      name: 'videoLayer',
      meta: {
        title: '课程详情'
      },
      component: videoLayer
    },
    {
      path: '/liveLayer',
      name: 'liveLayer',
      meta: {
        title: '直播'
      },
      component: liveLayer
    },
    {
      path: '/searchVue',
      name: 'searchVue',
      meta: {
        title: '搜索'
      },
      component: searchVue
    }
  ],
  linkActiveClass: 'choice',
  linkExactActiveClass: 'choice',
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})

vueRouter.beforeEach((to, from, next) => {
  let login = localStorage.getItem('login')
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path === '/liveLayer' || to.path === '/videoLayer' || to.path === '/login' || to.path === '/ForgetPassword' || to.path === '/ResetPassword') {
    store.state.HeadFooter = false
  } else {
    store.state.HeadFooter = true
  }
  if (to.path === '/index') {
    store.state.headindex = 0
  }
  if (to.path === '/CourseList') {
    store.state.headindex = 1
  }
  if (to.path === '/learning') {
    store.state.headindex = 2
  }
  if (to.path === '/live') {
    store.state.headindex = 3
  }
  if (to.path === '/newsList') {
    store.state.headindex = 4
  }
  if (login) { // 如果有就直接到首页咯
    next()
  } else {
    if (to.path === '/login' || to.path === '/register' || to.path === '/ForgetPassword') { // 如果是登录,注册，忘记密码，就直接next()
      next()
    } else { // 不然就跳转到登录；
      next({
        path: '/login',
        replace: true
      })
    }
  }
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js